// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as SmartImg$Showside from "../utils/SmartImg.bs.js";
import * as QuickView$Showside from "../components/QuickView.bs.js";
import * as BaseWithTheme$Showside from "../context/BaseWithTheme.bs.js";
import * as ErrorBoundary$Showside from "../utils/ErrorBoundary.bs.js";
import * as QuickViewMedia$Showside from "../components/QuickViewMedia.bs.js";
import * as RouterProvider$Showside from "../context/RouterProvider.bs.js";
import * as PausePageScrolling$Showside from "../components/PausePageScrolling.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
import * as UseQuickViewPagination$Showside from "../hook/UseQuickViewPagination.bs.js";
import * as PictureInPictureContext$Showside from "../utils/PictureInPictureContext.bs.js";
function QuickViewOverlay(Props) {
  PausePageScrolling$Showside.usePausePageScrolling(undefined);
  var match = RouterProvider$Showside.useRouter(undefined);
  var route = match.route;
  ConfigurationProvider$Showside.use(undefined);
  var qvMediaId;
  qvMediaId = typeof route === "number" || route.TAG !== /* QuickView */3 ? undefined : route._0.mediaId;
  var config = UseQuickViewPagination$Showside.useQuickViewPagination(undefined, undefined);
  var getSourceEl = React.useCallback(function (param) {}, []);
  var match$1 = PictureInPictureContext$Showside.use(undefined);
  var setPictureInPicture = match$1.setMediaId;
  React.useEffect(function () {
    if (setPictureInPicture !== undefined) {
      Curry._5(setPictureInPicture, undefined, undefined, undefined, undefined, undefined);
    }
  }, [qvMediaId]);
  var renderMediaBackdrop = React.useCallback(function (media) {
    return Belt_Option.mapWithDefault(media.fallbackImageUrl, null, function (poster) {
      return React.createElement(SmartImg$Showside.ColorOverlay.make, {
        src: poster
      });
    });
  }, []);
  return React.createElement(BaseWithTheme$Showside.make, {
    initiator: "quickview",
    portal: true,
    children: React.createElement(ErrorBoundary$Showside.make, {
      componentName: "QuickView",
      redirect: match.back,
      children: React.createElement(QuickView$Showside.make, {
        config: config,
        getSourceEl: getSourceEl,
        renderMedia: QuickViewMedia$Showside.renderMedia,
        renderMediaBackdrop: renderMediaBackdrop
      })
    })
  });
}
QuickViewOverlay.displayName = "QuickViewOverlay";
var make = QuickViewOverlay;
var $$default = QuickViewOverlay;
export { make, $$default, $$default as default };
/* react Not a pure module */